import { DetailAction } from '../DetailAction';
import { confirmCancelDialog } from '../../../../pages/dialogs/ConfirmCancelDialog';
import { DetailTranslationKeys, PopupTranslationKeys } from '../../../../api/models/TranslationKeys';
import { Backend } from '../../../../api/Backend';
import { Lightning } from '@lightningjs/sdk';

export class EpgDeleteRecordingAction extends DetailAction {
  private programTitle: string;
  private recordingId: string;
  private isParentRecordingPage: boolean;
  constructor(backend: Backend, programTitle: string, recordingId: string, isParentRecordingPage = false) {
    super(backend);
    this.programTitle = programTitle;
    this.recordingId = recordingId;
    this.isParentRecordingPage = isParentRecordingPage;
  }

  override doAction(modalOwner: Lightning.Component | undefined = undefined) {
    this.owner?.fireAncestors(
      '$openDialog',
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      confirmCancelDialog(
        `${this._backend.translations.forKey(DetailTranslationKeys.detail_recording_delete_popup_title)} ${
          this.programTitle
        }`,
        this._backend.translations.forKey(DetailTranslationKeys.detail_recording_delete_confirm),
        this.deleteConfirmed.bind(this, modalOwner),
        undefined,
        this._backend.translations.forKey(PopupTranslationKeys.popup_btn_ok),
        this._backend.translations.forKey(PopupTranslationKeys.popup_btn_cancel)
      )
    );
  }

  deleteConfirmed(modalOwner: Lightning.Component | undefined) {
    // als epg ds dan reloadDetailContent, als RecordingDs dan moet closeModal
    return this._backend.cachedRecordingsApi.deleteRecording(this._backend, this.recordingId).then(() => {
      this.owner?.fireAncestors('$reloadDetailContent');
      if (this.isParentRecordingPage) {
        // signal cmsGrid to remove item
        if (modalOwner) modalOwner.fireAncestors('$removeEpgElement', modalOwner);
      }
    });
  }
}
